import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";

export const CustomFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, entidade, getFieldValue, handleInputChange, errors,
}) => {
  const Component = campo.component as React.FC<{
    value: any;
    onChange: (val: any) => void;
    campo: any;
    entidade: any;
    handleInputChange: (campo: string, valor: string | number | boolean) => void;
  }>;
  if (!Component) return null;
  return (
    <>
      <Component
        value={getFieldValue(campo.nome)}
        onChange={(val: any) => handleInputChange(campo.nome, val)}
        campo={campo}
        entidade={entidade}
        handleInputChange={handleInputChange}
      />
      {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
    </>
  );
};
